import React from 'react'
import styled from 'styled-components'
import ResourceInformation from '../ResourceInformation/ResourceInformation'
import PlaylistIcon from './Components/PlaylistIcon/PlaylistIcon'
import ResourceIcon from './Components/ResourceIcon/ResourceIcon'
import { Black, Dark, White } from '../../Constants/ColorChart'
import { Col, Container, Row } from 'react-bootstrap'
import isElectron from "is-electron";
import { useApolloClient } from "@apollo/client";
import TicketForm from "../TicketForm/TicketForm";
import DownloadRequestButton from "../Icons/DownloadManager/DownloadRequestButton";
import { connect } from "react-redux";
import {
    addToDownloadRequest,
    removeFromDownloadRequest,
    resetDownloadRequest
} from "../../../actions/downloadManager";

/*
 *  @Description:   Stateless component that presents a Header to be used on a Playlist or a Resource.
 */

const LeftSection = styled.div`
    height: 100%;
    
`;
const RightSection = styled.div`
    margin-top:0px;

`;

const UpperMiniTitle = styled.p`
    margin-bottom: 0px;
    margin-top: 10px;
    
    font-size: 11px;
    @media screen and (min-width: 768px){
        font-size: 13px;
    }
    @media screen and (min-width: 992px){
        font-size: 15px;
    }
    @media screen and (min-width: 1200px){
        font-size: 17px;
    }
    @media screen and (min-width: 1600px){
        font-size: 19px;
    }
    @media screen and (min-width: 1800px){
        font-size: 21px;
    }
`;

const Title = styled.p`
    margin-top: 0px;
    margin-bottom: 0px;
    font-weight: 100;

    font-size: 20px;
    @media screen and (min-width: 768px){
        font-size: 25px;
    }
    @media screen and (min-width: 992px){
        font-size: 35px;
    }
    @media screen and (min-width: 1200px){
        font-size: 45px;
    }
    @media screen and (min-width: 1600px){
        font-size: 55px;
    }
    @media screen and (min-width: 1800px){
        font-size: 60px;
    }
`;

const Description = styled.p`
    margin-top: 0px;
    font-weight: 300;
    
    font-size: 13px;
    @media screen and (min-width: 768px){
        font-size: 15px;
    }
    @media screen and (min-width: 992px){
        font-size: 17px;
    }
    @media screen and (min-width: 1200px){
        font-size: 19px;
    }
    @media screen and (min-width: 1600px){
        font-size: 21px;
    }
    @media screen and (min-width: 1800px){
        font-size: 23px;
    }
`;

const StyledWrapper = styled.div`
    line-height: 1.1;
    padding-top: 50px;
    padding-bottom: 1%;
    margin-top: 50px;
    width: ${ props => props.isPlaylist ? "100%" : "90%" };
    margin-left: auto;
    margin-right: auto;
    background: ${ props => props.background && props.background }
    color: ${ props => props.fontColor && props.fontColor }
    display: ${ props => props.width < 700 ? "block" : "flex" };
`;

const Header = ( props ) => {
    const {
        isPlaylist,
        itemId,
        title,
        description,
        isFav,
        availableOffline,
        elementCounter,
        children,
        playlist,
        resource,
        goBack,
        offline
    } = props;

    const background = isPlaylist ? Dark : White;
    const fontColor = isPlaylist ? White : Black;
    const iconColor = isPlaylist ? White : Black;
    const strokeColor = isPlaylist ? Black : White;
    const client = useApolloClient ();

    return (
        <StyledWrapper
            background={ background }
            fontColor={ fontColor }
            isPlaylist={ isPlaylist }
        >
            <Container>
                <Row>
                    <Col
                        lg={ 4 }
                        md={ 4 }
                        sm={ 2 }
                        xs={ 12 }
                    >
                        <LeftSection>
                            { isPlaylist ?
                                <PlaylistIcon/>
                                :
                                <ResourceIcon/>
                            }
                        </LeftSection>
                    </Col>
                    <Col
                        lg={ 8 }
                        md={ 8 }
                        sm={ 10 }
                        xs={ 12 }
                    >
                        <RightSection>
                            <UpperMiniTitle>{ props.upperMiniTitle }</UpperMiniTitle>
                            <Title>{ title }</Title>
                            <ResourceInformation
                                elementCounter={ elementCounter }
                                isFav={ isFav }
                                showElementCounter
                                showFav={ !offline }
                                showShareLink={ !offline }
                                availableOffline={ availableOffline }
                                showAvailableOffline={ isElectron () }
                                iconColor={ iconColor }
                                strokeColor={ strokeColor }
                                isInPlaylist={ resource ? resource.isInPlaylist : false }
                                playlist={ playlist }
                                resource={ resource }
                                itemId={ itemId }
                                title={ title }
                                goBack={ goBack }
                                apolloClient={ client }
                            />
                            {
                                isPlaylist &&
                                <DownloadRequestButton
                                    requestLength={ props.downloadRequest.length }
                                    invertColor={ true }
                                    request={ props.downloadRequest }
                                    resetDownloadRequest={ props.resetDownloadRequest }
                                />
                            }
                            <Description>{ description }</Description>

                            {
                                !isElectron () &&
                                process.env.REACT_APP_SEE_TICKETS === "1" &&
                                props.session &&
                                props.session.ticketingUUID &&
                                <TicketForm/>
                            }

                            { children && children.length > 1 ? children.map ( child => ( child ) ) : children }

                        </RightSection>
                    </Col>
                </Row>
            </Container>
        </StyledWrapper>
    );

}

const mapStateToProps = ( state ) => ( {
    downloadRequest: state.downloadManager.downloadRequest,
} )

export default connect ( mapStateToProps, {
    addToDownloadRequest,
    removeFromDownloadRequest,
    resetDownloadRequest
} ) ( Header );